module.exports = __webpack_public_path__ + "static/media/padang.c1448912.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sound/padang.mp3
// module id = 144
// module chunks = 0